<template>
  <div class="kp-modular-row clearfix">
    <label>{{$t('edit.sidebar.visibility')}}<span klickart-info-tutorial="edit-visibility"></span></label>
    <div class="kp-modular-check pull-right kp-modular-check-with-icon">
      <input
        @change="onChange($event)"
        :checked="getValue()"
        type="checkbox"/>
      <span></span>
      <i class="fa fa-eye"></i>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  props: [
    'item',
    'general',
  ],
  methods: {
    getValue() {
      const style = this.stepStyle(this.item);
      return style.display !== 'none';
    },
    onChange(event) {
      const { checked } = event.target;
      const display = checked ? 'block' : 'none';

      if (this.general) {
        return this.quizUpdateStyle({ item: this.item, rule: 'display', value: display });
      }

      return this.stepUpdateStyle({ item: this.item, rule: 'display', value: display });
    },
    ...mapActions([
      'quizUpdateStyle',
      'stepUpdateStyle',
    ]),
  },
  computed: mapGetters({
    stepStyle: 'stepStyle',
  }),
};
</script>



/** WEBPACK FOOTER **
 ** Display.vue?4b96d3e4
 **/